import { codecs, createPath } from "@pomle/paths";

const root = createPath("/", {});

const locationSelector = root.append("/location-selector", {});

const featureFlags = root.append("/feature-flags", {});

const selectVisit = root.append("/select-visit", {});

const selectActiveVisit = root.append("/select-active-visit", {});

const selectVisitConfirm = selectVisit.append("/confirm/:patientId/:visitId", {
  patientId: codecs.string,
  visitId: codecs.string,
});

const assignSlot = root.append("/assign-slot/:siteId/:sessionId", {
  siteId: codecs.string,
  sessionId: codecs.string,
});

const checkIn = root.append("/check-in/:patientId/:visitId", {
  patientId: codecs.string,
  visitId: codecs.string,
});

const awaitingConsent = checkIn.append("/awaiting-consent", {});

const counterSign = checkIn.append("/counter-sign-consent", {});

const identityCheck = checkIn.append("/identity-check", {});

const preferredName = checkIn.append("/preferred-name", {});

const immediateRiskAssessment = checkIn.append(
  "/immediate-risk-assessment",
  {}
);

const assignToRoom = checkIn.append("/assign-to-room", {});

const assignToSkinScanner = checkIn.append("/assign-to-skin-scanner", {});
const assignToNoravECGDevice = checkIn.append(
  "/assign-to-norav-ecg-device",
  {}
);

const checkInSuccess = checkIn.append("/success", {});

const manualCheckInConfirmed = checkIn.append("/manual-confirmed", {});

const checkOut = checkIn.append("/checkout", {});

const followUpDerma = checkIn.append("/follow-up-derma", {});

const followUpEcg = checkIn.append("/follow-up-ecg", {});

const assignToNoravECGDeviceFollowUp = checkIn.append(
  "/assign-to-norav-ecg-device-follow-up",
  {}
);

const nekoLensAuth = checkIn.append("/neko-scope-auth", {});

const assignVials = checkIn.append("/assign-vials", {});

const drawConfirmation = checkIn.append("/draw-confirmation", {});

export const paths = {
  featureFlags,
  identityCheck,
  manualCheckInConfirmed,
  assignToRoom,
  assignToSkinScanner,
  assignToNoravECGDevice,
  assignVials,
  drawConfirmation,
  assignToNoravECGDeviceFollowUp,
  checkInSuccess,
  root,
  awaitingConsent,
  counterSign,
  assignSlot,
  preferredName,
  immediateRiskAssessment,
  checkOut,
  followUpDerma,
  followUpEcg,
  locationSelector,
  nekoLensAuth,
  selectVisit,
  selectActiveVisit,
  selectVisitConfirm,
  checkIn,
};
